import { MessageInput, useChannelActionContext } from 'stream-chat-react'
import { ChatSelectModeBar } from './ChatSelectModeBar'
import { ChatInput } from './ChatInput'
import { getCustomMessageData, normalizeMessageText } from '@packages/chat'
import { Chat } from '@/config'
import { useCallback } from 'react'

export type ChatFooterProps = {
  threadList?: boolean
}

const MemoizedChatFooter = (props: ChatFooterProps) => {
  const { selectModeActive } = Chat.Store.useSelectMode({ threadList: props.threadList })

  if (selectModeActive) { return (<ChatSelectModeBar threadList={props.threadList} />) }

  return (<CustomMessageInput threadList={props.threadList} />)
}
const CustomMessageInput = (props: ChatFooterProps) => {
  const { sendMessage } = useChannelActionContext('useSubmitHandler')

  const Input = useCallback(() => <ChatInput {...props} />, [props.threadList])

  return (
    <MessageInput
      Input={Input}
      hideSendButton
      overrideSubmitHandler={({ localMessage, message, sendOptions }) => {
        const normalizedText = normalizeMessageText(message.text || '')

        if (!normalizedText && !localMessage.attachments?.length) {
          return Promise.resolve()
        }

        const customData = getCustomMessageData({
          text: normalizedText,
          attachments: localMessage.attachments,
          mentionedUsers: message.mentioned_users,
        })

        const _message = {
          ...message,
          text: normalizedText,
          ...customData,
        }

        const _localMessage = {
          ...localMessage,
          text: normalizedText,
          ...customData,
        }

        return sendMessage({
          localMessage: _localMessage,
          message: _message,
          options: sendOptions,
        })
      }}
    />
  )
}

export const ChatFooter = MemoizedChatFooter
